import React from 'react'
import {
    BackButton,
    BlocErreur,
    BlocLoading,
    BlocTextField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue24() {
    return (
        <div>
             <Conditionnal
                linked_data_id="tech_mobile_num_a_valider"
                isEqualTo
                targetDataValueCompare={null}
            >

                <Header
                    title="J'estime mon prêt"
                    subTitle="Vérification de l'adresse mail"
                />
            </Conditionnal>

            <Conditionnal
                linked_data_id="tech_mobile_num_a_valider"
                isNotEqualTo
                targetDataValueCompare={null}
            >

                <Header
                    title="J'estime mon prêt"
                    subTitle="Vérification du numéro de téléphone"
                />
            </Conditionnal>

            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>
            <div className="Container">
                <Conditionnal
                    linked_data_id="tech_mobile_code_errone"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <BlocErreur
                        key="key1deddde49"
                        label="Code incorrect, réessayez."
                    />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="tech_mobile_num_a_valider"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <BlocTextField
                        key="key1dede49"
                        linked_data_id="tech_mobile_code_sms"
                        label="Code de sécurité reçu par SMS"
                        placeholder=" ex: XYZA"
                        removeEspace
                    />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="tech_mobile_num_a_valider"
                    isEqualTo
                    targetDataValueCompare={false}
                >
                    <BlocLoading message_principal="Vérification du numéro de téléphone mobile" />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="tech_mobile_num_a_valider"
                    isEqualTo
                    targetDataValueCompare={null}
                >

                    <BlocErreur
                        key="key1deddde49"
                        label="Cette adresse mail ne peut être utilisée pour créer un dossier."
                    />
                </Conditionnal>
            </div>
            <Conditionnal
                linked_data_id="tech_mobile_num_a_valider"
                isEqualTo
                targetDataValueCompare={true}
            >
                <Conditionnal
                    linked_data_id="tech_mobile_relance_code_ok"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <div className="SubmitButtonContainer">
                        {' '}
                        <Button text="Renvoyer un code " buttonSMS />
                    </div>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="tech_mobile_relance_code_ok"
                    isEqualTo
                    targetDataValueCompare={false}
                >
                    <div className="SubmitButtonContainer">
                        {' '}
                        <Button
                            text="Renvoyer un code (20 secondes)"
                            buttonSMS
                            disabled
                        />
                    </div>
                </Conditionnal>

                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Valider code" EnrDossier />
                </div>
            </Conditionnal>
        </div>
    )
}
